import { useContext } from 'react'

import { Button } from 'antd'
import { useSelector } from 'react-redux'

import { IndividualInternshipRequestModalContext } from '../../../Providers/Forms/IndividualInternshipRequest/IndividualInternshipRequestModal'
import { InternshipRequest, Origins } from '../../../utils/entities/internshipRequest'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const InternshipRequestButton = ({ student, reload }) => {
  const { setHandler } = useContext(IndividualInternshipRequestModalContext)

  const t = useSelector(selectTranslate)

  return (
    <Button
      className='mt-12'
      type='primary'
      onClick={() => setHandler(form => ({ ...form, data: new InternshipRequest({ student, requestOrigin: Origins.INTERNEO }), callback: reload }))}
    >
      {t('internship_views.individual_internship_request_button')}
    </Button>
  )
}

export default InternshipRequestButton
